import { AnalyticsController } from 'analytics/analytics-controller';
import { AREA_PAGE_FILTER_OPTION_TO_GTM_EVENT } from 'constants/area-map-page-filters';
import { GTM_CATEGORY_AREA_PAGE_V2 } from 'constants/events';

/**
 * Area-page-v2 GTM helper.
 * Tag each event with `event_category = area-page-v2` so that we can distinguish between classic and new area page events without needing to rename the events or have another prefix for these events.
 */
export function trackAreaPageV2Event(event: string, label?: string, value?: number): void {
  AnalyticsController.trackEvent(event, GTM_CATEGORY_AREA_PAGE_V2, label, value);
}

export function trackAreaPageV2FilterChange(changedFilter?: string): void {
  if (!changedFilter) {
    return;
  }
  if (!(changedFilter in AREA_PAGE_FILTER_OPTION_TO_GTM_EVENT)) {
    return;
  }
  trackAreaPageV2Event(
    AREA_PAGE_FILTER_OPTION_TO_GTM_EVENT[changedFilter as keyof typeof AREA_PAGE_FILTER_OPTION_TO_GTM_EVENT]
  );
}
